"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function capitalizeFirstOnly(string) {
    if (!string)
        return string;
    return string[0].toLocaleUpperCase() + string.slice(1);
}
exports.default = capitalizeFirstOnly;
